<!-- app.component.html -->
<div class="app-container">
  
  <!-- Floating Toggle Button -->
  <button mat-fab class="nav-toggle-btn" (click)="toggleNav()" [ngClass]="{'nav-hidden': !isNavVisible}">
    <mat-icon>{{ isNavVisible ? 'close' : 'menu' }}</mat-icon>
  </button>

  <nav class="navbar" *ngIf="isNavVisible"
    (touchstart)="onTouchStart($event)"
    (touchmove)="onTouchMove($event)"
    (touchend)="onTouchEnd()">
    <mat-toolbar>
      <button mat-icon-button class="example-icon" routerLink="login" routerLinkActive="active" ariaCurrentWhenActive="page" aria-label="Login">
        <mat-icon>login</mat-icon>
      </button>
      <button mat-icon-button class="example-icon" routerLink="fishing" routerLinkActive="active" ariaCurrentWhenActive="page" aria-label="Fishing">
        <mat-icon>directions_boat</mat-icon>
      </button>
      <span class="example-spacer"></span>
      <button mat-icon-button class="example-icon" routerLink="maps" routerLinkActive="active" ariaCurrentWhenActive="page" aria-label="Maps">
        <mat-icon>map</mat-icon>
      </button>
<button mat-icon-button class="example-icon" routerLink="catches" routerLinkActive="active" ariaCurrentWhenActive="page" aria-label="Catches">
        <mat-icon>set_meal</mat-icon>
      </button>
      <button mat-icon-button class="example-icon" routerLink="trips" routerLinkActive="active" ariaCurrentWhenActive="page" aria-label="Trips">
        <mat-icon>history</mat-icon>
      </button>
      <button mat-icon-button class="example-icon" routerLink="spots" routerLinkActive="active" ariaCurrentWhenActive="page" aria-label="Spots">
        <mat-icon>place</mat-icon>
      </button>
      <button mat-icon-button class="example-icon" routerLink="settings" routerLinkActive="active" ariaCurrentWhenActive="page" aria-label="Settings">
        <mat-icon>settings</mat-icon>
      </button>
    </mat-toolbar>
  </nav>

  <main
    #mainContent
    class="main-content"
    [ngClass]="{'full-height': !isNavVisible}"
  >
    <router-outlet />
  </main>
</div>
<app-toast></app-toast>
